import { MetricType, onTTFB, onFID, onFCP, onLCP, onCLS } from 'web-vitals';
import Logging from '../../../core';

export const reportWebVitals = () => {
  onCLS(logWebVitalMetric);
  onFID(logWebVitalMetric);
  onFCP(logWebVitalMetric);
  onLCP(logWebVitalMetric);
  onTTFB(logWebVitalMetric);
};

export const logWebVitalMetric = (metric: MetricType) => {
  Logging.info(`Web Vital metric (name: ${metric.name}, rating: ${metric.rating})`, {
    id: metric.id,
    name: metric.name,
    rating: metric.rating,
    value: metric.value,
    data: JSON.stringify(metric),
  });
};
